"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nextCalendarPage = exports.prevCalendarPage = exports.getPageFromDate = void 0;

var _SimpleDate = require("../../core/SimpleDate");

/**
 * @param {SimpleDate} date
 * @returns {Object} An object of the form { year, month }
 */
var getPageFromDate = function getPageFromDate(date) {
  if (!(0, _SimpleDate.isValid)(date)) return null;
  return {
    year: date.year,
    month: date.month
  };
};
/**
 * @param {Object} calendarPage An object of the form `{ year, month }`
 * @returns {Object} An object of the form `{ year, month }` for the previous month
 */


exports.getPageFromDate = getPageFromDate;

var prevCalendarPage = function prevCalendarPage(_ref) {
  var month = _ref.month,
      year = _ref.year;
  var newMonth = (month + 11) % 12;
  var newYear = newMonth === month - 1 ? year : year - 1;
  return {
    month: newMonth,
    year: newYear
  };
};
/**
 * @param {Object} calendarPage An object of the form `{ year, month }`
 * @returns {Object} An object of the form `{ year, month }` for the next month
 */


exports.prevCalendarPage = prevCalendarPage;

var nextCalendarPage = function nextCalendarPage(_ref2) {
  var month = _ref2.month,
      year = _ref2.year;
  var newMonth = (month + 1) % 12;
  var newYear = newMonth === month + 1 ? year : year + 1;
  return {
    month: newMonth,
    year: newYear
  };
};

exports.nextCalendarPage = nextCalendarPage;